module.exports = __webpack_public_path__ + "img/fbicon.35be65ac.svg";